<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        class="transition-transform"
        :class="[
            {'rotate-180': direction === 'left'},
            {'rotate-90': direction === 'down'},
            {'-rotate-90': direction === 'up'}
        ]"
        viewBox="0 0 320 512"
        fill="currentColor"
    ><!-- !Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. -->
        <path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/>
    </svg>
</template>

<script lang="ts" setup>
const props = defineProps({
    test: Boolean,
    direction: {
        type: String as PropType<'left' | 'down' | 'up' | 'right'>
    }
    // direction: {
    //   type: String as PropType<''>()
    // }
})
</script>
